import React from "react";
import GeneralTable from "../../components/Table/GeneralTable";
import { useTranslation } from "react-i18next";

export default function MaintenancePauseReason() {
    const { t } = useTranslation("translation");

    return (
        <div>
            <GeneralTable
                id="mpr_gt"
                table="MaintenancePauseReason"
                resourcePath="GetDetailedList"
                title={t("MaintenancePauseReason")}
                search={t("SearchMaintenancePauseReason")}
            />
        </div>
    );
}
